import { render, staticRenderFns } from "./IssueListFilter.vue?vue&type=template&id=59631fd3"
import script from "./IssueListFilter.vue?vue&type=script&lang=js"
export * from "./IssueListFilter.vue?vue&type=script&lang=js"
import style0 from "./IssueListFilter.vue?vue&type=style&index=0&id=59631fd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports